export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "Label telah berjaya ditambahkan kepada Akaun Perdagangan anda.",
        ok: "OK",
        add_account_label: "Tambah Label Akaun",
        trading_account: "Akaun Perdagangan",
        select_trading_id: "Pilih ID Perdagangan",
        label: "Label",
        alpha_numeric_characters : "Berikan label kepada akaun anda: (Abjad angka sehingga 15 aksara)",
        apply: "Terap",
        cancel: "Batal",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "Kami telah menerima permintaan anda untuk menukar leveraj ID perdagangan anda",
        from :"dari",
        to :"ke",
        confirm_mail_id:"Untuk mengesahkan, sila klik pada pautan pengesahan yang dihantar ke ID e-mel berdaftar anda.",
        leverage_successfully_change:"Permintaan leveraj tukar berjaya diproses",
        change_account_leverage:"Ubah Leveraj Akaun",
        select_trading_account :"Pilih Akaun Trading",
        existing_leverage :"Leveraj Sedia Ada",
        new_leverage :"Leveraj Baru",
        select_new_leverage :"Pilih leveraj baharu",
        change_leverage:"Tukar Leveraj",
        account_leverage_reduced :"Jika leveraj akaun dikurangkan daripada leveraj semasa, ia akan meningkatkan margin terpakai pada dagangan terbuka anda (jika ada).",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"Ia adalah wajib untuk melengkapkan KYC sebelum membuat lebih daripada satu akaun Langsung.",
        submit_proof_address:"Sila serahkan bukti alamat menggunakan tiket sokongan",
        click_here:"Tekan di sini",
        email_to: "atau e-mel kepada",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "Bukti Alamat berikut diterima:",
        utility_bill: "Bil Utiliti",
        bank_statement: "Penyata Bank",
        government_issued:"Dokumen Cukai Keluaran Kerajaan",
        note:"Catatan",
        proof_of_address:"Bukti alamat diperlukan tidak melebihi 4 bulan.",
        account :"Akaun",
        select_platform:"Pilih Platform",
        select_account_type:"Pilih Jenis Akaun",
        connect_your_account:"Adakah anda mahu menyambungkan akaun anda ke ZuluTrade?",
        select_leverage:"Pilih Leveraj",
        select_account_base_currency:"Pilih mata wang Asas Akaun",
        select_currency:"Pilih Mata Wang",
        Password:"Kata laluan",
        minimum_password_length5:"Panjang kata laluan minimum ialah 5 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        minimum_password_length8:"Panjang kata laluan minimum ialah 8 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        spcl_characters:"# aksara",
        lowercase_letter:"Huruf kecil",
        capital_letter:"Huruf besar",
        number: "Nombor",
        special_character:"Aksara khas",
        confirm_password :"Sahkan Kata Laluan",
        trade_With_virtual_funds:"Trade With Virtual Funds",
        test_strategies:"Test Strategies for Free",
        risk_free_trading:"Dagangan Tanpa Risiko",
        live_market_feed: "Suapan Pasaran Langsung",
        liquidity_from_top :"Liquidity From Top LPs",
        effective_trading:"Alat Dagangan Berkesan",
        instant_execution:"Pelaksanaan Segera",
        low_commissions:"Komisen dan Spread Rendah",
        create_new:"Buat baru",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "Dayakan Pengesahan 2 Faktor",
        click_to_enable: "Klik untuk Mendayakan",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"Kami telah menerima permintaan anda untuk memindahkan",
        from_trading_account:"daripada akaun dagangan",
        to_confirm:"Untuk mengesahkan, sila klik pautan pengesahan yang dihantar kepada ID e-mel berdaftar anda.",
        internal_transfer_request:"Permintaan pemindahan dalaman anda daripada akaun",
        for_amount:"untuk amaun",
        to_account:"ke akaun",
        was_succesfull :"telah berjaya dengan sejumlah",
        internal_transfer: "Pemindahan Dalaman",
        transfer_From: "Pindahkan Daripada",
        transfer_to:"Transfer To",
        balance: "Baki",
        enter_amount: "Masukkan Amaun",
        USE_MAX:"USE MAX",
        proceed:"Teruskan",
        Internal_Transfer_ZIP:"Internal Transfer is not avaliable for ZTP account.",
        In_case_of_internal_transfer:"Nota: Dalam kes pemindahan dalaman antara akaun dengan mata wang asas yang berbeza, amaun yang dipindahkan adalah mengikut harga pasaran lazim.",
        
        /*=== manage-account.vue ====*/
        attention :"Perhatian - Anda akan meminta untuk memadamkan ID Dagangan",
        note_after_requesting:"Nota: - Selepas meminta, akaun anda akan dipadamkan daripada rekod dan anda tidak akan dapat mengembalikannya.",
        after_clicking:"Selepas mengklik pada butang sahkan, anda akan mendapat pautan pengesahan pada ID e-mel berdaftar anda untuk memadamkan akaun dagangan anda",
        currency: "Mata Wang",
        Account_Type: "Jenis Akaun",
        Account_Label: "Label Akaun",
        Bonus: "Bonus",
        Leverage: "Leveraj",
        Equity: "Ekuiti",
        Create_Demo_Account: "Cipta Akaun Demo",
        Create_Live_Account :"Mencipta Akaun Langsung",
        internal_transfer_CAP:"PEMINDAHAN DALAMAN",
        web_trading:"WEB TRADING",
        add_account_label_CAP:"ADD ACCOUNT LABEL",
        change_laverage:"Tukar Leveraj",
        delete_account:"Padam Akaun",
        reset_trading_password:"TETAP SEMULA KATA LALUAN PERDAGANGAN",
        
        verifying_your_request: "Mengesahkan permintaan anda...",
        success: "BERJAYA",
        error: "RALAT",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"Kami telah menerima permintaan anda untuk menetapkan semula kata laluan Pelabur. Untuk mengesahkan, sila klik pada pautan pengesahan yang dihantar ke ID e-mel berdaftar anda",
        change_investor_password:"Tukar Investor Kata Laluan Berjaya.",
        reset_investor_password:"Menetapkan Investor Semula Kata Laluan",
        investor_password:"Investor Kata laluan",
        master_password:"Master Kata laluan",
        trading_iD: "ID Perdagangan",
        enter_new_password:"Kata Laluan Baharu",
        confirm_new_password :"Sahkan Kata Laluan Baharu",
        password_must_contain:"Kata laluan anda mesti mengandungi min. 6 aksara dan maks 10 aksara, sekurang-kurangnya 1 angka, 1 aksara besar dan 1 aksara Khas (!@$%*)",
        change_Password:"Tukar Kata Laluan",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"Menetapkan Master Semula Kata Laluan",
        click_reset:"Klik di sini untuk menetapkan semula",
        password_caption:"Kata Laluan Pelabur ialah kata laluan Baca sahaja, yang tidak membenarkan peniaga pengguna. Jika anda log masuk menggunakan Kata Laluan Utama, anda mendapat akses penuh dan hak perdagangan dalam akaun.",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "Korporat",
        account_type: "Jenis Akaun",
        select_account_type: "Pilih Jenis Akaun",
        individual: "Individu",
        name_of_company: "Nama syarikat",
        country_of_company: "Negara syarikat",
        select_company_country: "Pilih negara syarikat",
        registration: "Pendaftaran",
        email_company: "E-mel syarikat",
        Password: "Kata laluan",
        min_password_length8: "Panjang kata laluan minimum ialah 8 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        spcl_characters: "# aksara",
        lowercase_letter: "Huruf kecil",
        capital_letter: "Huruf besar",
        number: "Nombor",
        special_character: "Aksara khas",
        confirm_password: "Sahkan Kata Laluan",
        Phone_Number: "Nombor Telefon",
        have_read: "Saya telah membaca, memahami dan menerima",
        terms_conditions: "Terma dan Syarat",
        accept_terms_conditions: "Sila terima terma dan syarat",
        given_your_residency: "Berdasarkan taraf pemastautin anda, anda akan menerima Perkhidmatan Pelaburan Pakar Triple A (GR) yang dikawal selia oleh HCMC. Anda boleh melihat perlindungan dan terma & syarat yang tersedia di laman web kami. Dengan mengklik ",
        continue: "teruskan",
        triple_investment_services: "anda bersetuju dengan pembukaan akaun anda dengan Perkhidmatan Pelaburan Pakar Triple A (GR).",
        register: "DAFTAR",
        already_have_account: "Sudah mempunyai akaun?",
        login: "Log masuk",
        /*=== forgot-password.vue ====*/
        confirmation_link: "Pautan pengesahan telah dihantar kepada ID e-mel berdaftar anda. Sila klik pautan untuk menetapkan semula kata laluan log masuk anda.",
        ok: "OK",
        this_email_address: "Alamat e-mel ini tidak didaftarkan dengan kami.",
        click_here: "Klik di sini",
        create_account_now: "untuk mencipta akaun sekarang",
        forgot_password: "Lupa Kata Laluan",
        email_address: "Alamat E-mel",
        submit: "Serah",
        dont_have_account: "Tiada akaun?",
        create_account_now_CAP: "CIPTA AKAUN SEKARANG!",
        /*=== login.vue ====*/
        client_login: "Log Masuk Pelanggan",
        remember_me: "Ingat saya",
        two_step_verification: "Pengesahan Dua Langkah",
        google_authenticator: "Sila masukkan kod laluan sekali sahaja yang ditunjukkan dalam ap Google Authenticator.",
        google_auth_code: "Kod Pengesahan Google",
        /*=== register.vue ====*/
        sent_an_OTP: "Kami telah menghantar OTP kepada",
        complete_your_registration: "Sila masukkannya untuk mengesahkan dan melengkapkan pendaftaran anda.",
        otp: "OTP",
        Register_heading: "Daftar",
        first_name: "Nama pertama",
        last_name: "Nama akhir",
        email: "E-mel",
        country: "Negara",
        select_residence_country: "Pilih negara tempat tinggal",
        privacy_policy: "Dasar Privasi",
        accept_privacy_policy: "Sila terima dasar privasi",
        experts_investment_services: "Berdasarkan taraf pemastautin anda, anda akan menerima Perkhidmatan Pelaburan Pakar Triple A (GR) yang dikawal selia oleh HCMC. Anda boleh melihat perlindungan dan terma & syarat yang tersedia di laman web kami. Dengan mengklik ",
        opening_your_account: "anda bersetuju dengan pembukaan akaun anda dengan Perkhidmatan Pelaburan Pakar Triple A (GR).",
        /*=== reset-password.vue ====*/
        login_password_change: "Kata laluan log masuk anda telah berjaya ditukar.",
        reset_password: "Menetapkan Semula Kata Laluan",
        reset: "Tetapkan semula",
    },
    //H
    copy_trading: {
        copy_trading: "Perdagangan Salin",
        copy_trading_header: "Peroleh keuntungan dengan menyalin perdagangan pengurus strategi secara automatik",
        leading_traders: "MENYALIN PEDAGANG TERKEMUKA SECARA AUTOMATIK",
        diversified_trading: "PORTFOLIO PERDAGANGAN YANG PELBAGAI",
        monitor_profit: "PANTAU & UNTUNG",
        copy_traders: "BAGAIMANA CARA MENYALIN PERDAGANGAN?",
        one: "1.",
        one_header: "Buka Akaun Langsung dan buat deposit.",
        two: "2.",
        two_header: "Pilih Pengurus Strategi.",
        three: "3.",
        three_header: "Bersetuju dengan terma dan syarat.",
        four: "4.",
        four_header: "Berikan kepada kami perjanjian anda.",
        five: "5.",
        five_header: "Dapatkan keuntungan dengan menyalin perdagangan.",
        order_processing: "PEMPROSESAN PESANAN PANTAS",
        end_result: "KAWALAN TERHADAP KEPUTUSAN AKHIR",
        trading_skills: "TINGKATKAN KEMAHIRAN BERDAGANG ANDA",
        start: "Start"
    },
    downloads: {
        mt_four_desktop: "MT4 Desktop",
        mt_four_android: "MT4 Android",
        mt_four_ios: "MT4 iOS",
        mt_four_web_trader: "MT4 Web Trader",
        mt_five_desktop: "MT5 Desktop",
        mt_five_android: "MT5 Android",
        mt_five_ios: "MT5 iOS",
        mt_five_web_trader: "MT5 Web Trader",
        act_trader_desktop: "Act Trader Desktop",
        act_trader_android: "Act Trader Android",
        act_trader_ios: "Act Trader iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "Adakah anda pasti mahu menjadikan VPS tersedia",
        package: "Pakej?",
        yes: "Ya",
        no: "TIDAK",
        downloads: "Muat turun",
        copy_trading: "Perdagangan Salin",
        vps: "VPS"
    },
    vps: {
        vps_plans: "Pelan VPS",
        bronze: "GANGSA",
        monthly_subscription_twenty_five: "Langganan Bulanan $25",
        free_deposit_five_thousand: "Dapatkannya percuma dengan deposit $5,000 ke atas",
        compatible_mt_four_five_act: "Serasi dengan MT4, MT5 dan Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "Ruang Cakera Percuma 25 GB | 1300 MB RAM | 1 VCPU",
        windows_linux_support: "Windows 8/10/12, Linux Disokong",
        avail_now: "Jadikan Tersedia Sekarang",
        silver: "PERAK",
        monthly_subscription_fourty_five: "Langganan Bulanan $45",
        free_on_deposit_ten_thousand: "Dapatkannya percuma dengan deposit $10,000 ke atas",
        free_fifty_gb_disk_space_ram_vcpu: "Ruang Cakera 50 GB Percuma | 2700 MB RAM | 2 VCPU",
        gold: "EMAS",
        monthly_subscription_eighty: "Langganan Bulanan $80",
        free_on_deposit_fifteen_thousand: "Dapatkannya percuma dengan deposit $15,000 ke atas",
        free_seventy_five_gb_disk_space_ram_vcpu: "Free 75 GB Disk Space | 5120 MB RAM | 3 VCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "Batalkan Permintaan Pengeluaran",
        cancel_your_withdrawal_request: "Adakah anda pasti mahu membatalkan Permintaan Pengeluaran anda",
        process_request: "Proses Permintaan",
        open_tickets: "Tiket Terbuka",
        back: "Kembali",
        ticket_number: "Nombor Tiket:",
        created: "Dicipta:",
        reason: "Reason:"
    },
    bonus: {
        request_to_avail_bonus: "Permintaan anda untuk menjadikan bonus tersedia sebanyak",
        trading_id: "untuk ID perdagangan",
        click_confirmation_link: "telah diterima. Untuk mengesahkan, sila klik pautan pengesahan yang dihantar kepada ID e-mel berdaftar anda.",
        request_to_remove_bonus: "Permintaan anda untuk mengalih keluar bonus sebanyak",
        bonus_amount: "Amaun bonus anda sebanyak",
        successfully_removed_account: "telah berjaya dialih keluar daripada id akaun",
        ok: "OK",
        request_to_add_bonus: "Permintaan anda untuk menambah bonus sebanyak",
        successfully: "telah berjaya.",
        bonus: "BONUS",
        select_trading_id: "Pilih ID Perdagangan",
        use_max: "Gunakan Maks",
        account_type: "Jenis Akaun",
        equity: "Ekuiti",
        leverage: "Leveraj",
        currency: "Mata Wang",
        current_bonus: "Bonus Semasa",
        allowed_bonus: "Bonus yang Dibenarkan",
        remove: "Alih Keluar",
        account_first: "Sila pilih akaun dahulu",
        bonus_amount_base_currency: "Catatan: Masukkan Amaun Bonus dalam Mata Wang Asas.",
        point_one: "1. Tawaran Bonus 100% kami tersedia kepada semua pelanggan yang membuat deposit minimum sebanyak USD 100 dan dengan leveraj akaun hingga 1:200. Bonus maksimum yang dibenarkan ialah USD 40,000 setiap pelanggan.",
        point_two: "2. Keuntungan yang diperoleh daripada perdagangan melalui bonus kami akan menjadi milik anda. Bonus tidak akan dikeluarkan jika anda mengeluarkan keuntungan anda.",
        point_three: "3. Bonus meningkatkan margin anda yang tersedia dalam akaun. Walau bagaimanapun, kerugian anda tidak boleh dimasukkan ke dalam bonus. Jika jumlah kerugian pada perdagangan anda melebihi dana anda sendiri, sistem akan menghentikan secara automatik kedudukan dalam akaun perdagangan anda tanpa sebarang pemberitahuan terlebih dahulu.",
        point_four: "4. Jumlah bonus yang berkadar akan dikeluarkan daripada akaun anda jika anda membuat pengeluaran dana anda sendiri.",
        read_understood_accepted: "Saya telah membaca, memahami dan menerima",
        aaafx_bonus_policy: "Dasar Bonus AAAFx.",
        accept_aaafx_bonus_policy: "Sila terima dasar bonus AAAFx",
        proceed: "Teruskan",
        no_bonus_available_account: "No bonus available for this account"
    },
    refer_earn: {
        bonus: "BONUS",
        refer_earn: "RUJUK DAN DAPATKAN WANG",
        refer_friend: "Rujukkan rakan",
        earn_dollar_twenty_five: "Dapatkan $25",
        per_friend: "setiap rakan",
        why_refer_someone_to_us: "Mengapa anda perlu merujukkan seseorang kepada kami?",
        refer_someone_point_one: "1. Anda dan rakan anda mendapat manfaat daripada bonus rujukan.",
        refer_someone_point_two: "2. Prosedur yang mudah dan cepat",
        refer_someone_point_three: "3. Anda berdua mendapat manfaat daripada keadaan perdagangan kami yang menggalakkan.",
        refer_someone_point_four: "4. Pendapatan daripada rujukan tidak terhad.",
        what_need_to_do: "Inilah yang anda perlu lakukan:",
        what_need_to_do_point_one: "1. Kongsi pautan rujukan anda dengan rakan sekutu anda.",
        what_need_to_do_point_two: "2. Rujukan anda mendaftar menggunakan pautan anda dan mula berdagang.",
        what_need_to_do_point_three: "3. Sebaik sahaja rujukan anda layak, anda berdua akan mendapat $25 setiap seorang.",
        referral_list: "Your Referral List"
    },
    referral_list: {
        referrals_list: "Senarai rujukan",
        list_of_referrals: "Senarai rujukan untuk menjejak pendapatan anda.",
        s_no: "No.S",
        name: "Nama",
        email_id: "ID e-mel",
        account_stage: "Peringkat Akaun",
        deposits: "Deposit",
        volume_required: "Volum Diperlukan",
        traded_volume: "Volum Didagangkan",
        qualified: "Layak",
        no_data: "Tiada data",
        payment_of_referral_bonus: "Pembayaran Bonus Rujukan hendaklah dilakukan pada minggu selepas minggu yang Rujukan telah layak.",
        referral_bonus_paid_in_aaafx_wallet: "Bonus Rujukan hendaklah dibayar dalam dompet AAAFx USD yang Perujuk dan Rujukan boleh sama ada keluarkan atau pindahkan kepada akaun perdagangan mereka.",
        read_all_terms_conditions: "Baca semua Terma dan Syarat",
        here: "di sini",
        contact_us: "Soalan? Hubungi kami di Sembang Langsung 24/5 atau e-mel kepada kami di",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "Takrifan",
        meaning_of_all_above_columns: "Berikut ialah maksud semua lajur di atas untuk rujukan anda:",
        name_of_your_referral: "- Nama rujukan anda.",
        meaning_of_various_stages: "- Sila lihat di bawah untuk maksud pelbagai peringkat.",
        registered: "1. Berdaftar:",
        registered_link: "Rujukan anda telah mendaftar menggunakan pautan anda.",
        funded: "2. Dibiayai:",
        referral_deposited: "Rujukan anda telah membuat deposit.",
        third_point_qualified: "3. Layak:",
        referral_has_deposited: "Rujukan anda telah mendepositkan dan mencapai volum dagangan yang diperlukan. Anda berdua kini layak mendapat ganjaran.",
        deposits_made_by_referral: "- Deposit dibuat oleh rujukan anda.",
        volume_requirement: "Keperluan volum",
        volume_required_for_reward: "- Volum yang diperlukan untuk rujukan anda layak mendapat ganjaran.",
        volume_your_referral_traded: "- Volum yang sebenarnya telah didagangkan oleh rujukan anda.",
        referral_qualified_for_reward: "- Sama ada rujukan anda telah layak mendapat keperluan ganjaran atau belum.",
        referral_ib_programs: "Selepas memperoleh ganjaran pada 10 rujukan, anda boleh menjadi IB atau meneruskan program Rujuk-dan-Peroleh dengan ganjaran $20 setiap satu untuk anda dan rujukan anda. Anda boleh membandingkan faedah dan ciri program Rujukan dan IB kami"
    },
    calculators_common: {
        asset_class: "Kelas Aset",
        forex: "Forex",
        commodities: "Komoditi",
        indices: "Indeks",
        account_base_currency: "Mata Wang Asas Akaun",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "Simbol",
        select_symbol: "Pilih Simbol",
        trade_size_in_lots: "Saiz Dagangan (dalam lot)",
        calculate: "Calculate"
    },
    margin: {
        margin_required: "Margin Diperlukan:",
        maximum_leverage: "Maksimum Leveraj:"
    },
    pip: {
        pip_value: "Pip Value:"
    },
    swap: {
        server: "Pelayan",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "Bilangan hari",
        long_swap: "Swap Panjang:",
        short_swap: "Short Swap:"
    },
    //S
    dashboard:{
        select_trading_id: "Pilih ID Perdagangan",
        leverage: "Leveraj",
        balance: "Baki",
        equity: "Ekuiti",
        free_margin: "Margin Bebas",
        pnl: "PNL",
        web_trader : "Web Trader",
        fund: "Dana",
        promotions: "Promosi",
        hundred: "100",
        bonus: "Bonus",
        avail: "Jadikan Tersedia",
        deposit_bonus: "Bonus deposit",
        loading_initial_data: "Memuatkan data permulaan",
    },
    enable_2fa:{
        title: "Google Authentication (2FA)",
        description: "Untuk Mendayakan Pengesahan Dua Faktor (2FA) Google, imbas kod QR dan masukkan kod laluan sekali yang dijana di bawah.",
        google_authenticator_code: "Kod Google Authenticator",
        how_to_enable: "Untuk Mendayakan Pengesahan 2 Faktor:",
        download: "Muat turun",
        google_authenticator_app: "Ap Google Authenticator",
        on_mobile_tablet: "pada telefon bimbit/tablet anda.",
        scan_the : "Imbas",
        qr_code: "kod QR",
        appearing_above: "yang ditunjukkan di atas",
        enter_the: "Masukkan",
        passcode: "Kod laluan",
        appers_in_google_auth_app: "yang klelihatan dalam Aplikasi Google Authenticator anda",
        click_on_the_button: "Klik butang",
        click_to_enable: "Klik untuk Mendayakan",
    },
    account_security:{
        title: "Google Authentication (2FA)",
        description: "Untuk Mendayakan Pengesahan Dua Faktor (2FA) Google, imbas kod QR dan masukkan kod laluan sekali yang dijana di bawah.",
        google_authenticator_code: "Kod Google Authenticator",
        how_to_enable: "Untuk Mendayakan Pengesahan 2 Faktor:",
        download: "Muat turun",
        google_authenticator_app: "Ap Google Authenticator",
        on_mobile_tablet: "pada telefon bimbit/tablet anda.",
        scan_the : "Imbas",
        qr_code: "kod QR",
        appearing_above: "yang ditunjukkan di atas",
        enter_the: "Masukkan",
        passcode: "Kod laluan",
        appers_in_google_auth_app: "yang klelihatan dalam Aplikasi Google Authenticator anda",
        click_on_the_button: "Klik butang",
        click_to_enable: "Klik untuk Mendayakan",
    },
    change_pass:{
        success_message:"Your Password has been changed successfully.",
        ok:"OK",
        change_password: "Tukar Kata Laluan",
        existing_password: "Kata Laluan Sedia Ada",
        new_password: "Kata Laluan Baharu",
        confirm_new_password: "Sahkan Kata Laluan Baharu",
        note_one: "Kata laluan hendaklah mengandungi sekurang-kurangnya 7 dan maksimum 10 aksara, dan hendaklah mengandungi sekurang-kurangnya 1 nombor, 1 Huruf Besar dan 1 aksara khas {'(!@#$%^)'}.",
        note_two: "Sila ambil perhatian bahawa kata laluan Profil adalah berbeza daripada kata laluan akaun perdagangan anda",
        cancel: "Batal",
    },
    corporate_varify_step_three:{
        please_upload_file: "sila muat naik fail",
        out_of_documents: "daripada 8 Dokumen",
        add_file: "Tambah fail",
        max_file_size: "Maximum files size of can be uploaded up to"
    },
    corporate_varify:{
        corporation_info: 'Corporation Info',
        account_creation: "Penciptaan Akaun",
        verification: "Pengesahan",
        deposit: "Deposit",
        select_platform: "Pilih Platform",
        select_account_type: "Pilih Jenis Akaun",
        select_leverage: "Pilih Leveraj",
        select_base_currency: "Pilih mata wang Asas Akaun",
        select_currency: "Pilih Mata Wang",
        password: "Kata laluan",
        pass_length_alert: "Panjang kata laluan minimum ialah 5 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        of_characters: "daripada aksara",
        lowercase_letter: 'Lowercase letter',
        capital_letter : "Huruf besar",
        number: "Nombor",
        special_character : "Aksara khas",
        confirm_password: "Sahkan Kata Laluan",
        create_account : "Cipta Akaun",
    },
    corporation_info:{
        name_of_company: "Nama syarikat",
        country_of_company: "Negara syarikat",
        select_company_country: "Pilih negara syarikat",
        registration: "Pendaftaran",
        submit: "SERAH",
    },
    profile:{
        personal_details: "Maklumat Peribadi",
        uploaded_documents: "Dokumen yang Dimuat Naik",
        no_documents_yet: "Belum Ada Dokumen",
    },
    questions:{
        financial_details: "Butiran Kewangan",
        sub_heading_one: "Jumlah Anggaran Pendapatan Tahunan",
        select_annual_income: "Pilih Pendapatan Tahunan",
        sub_heading_two: "Jumlah Anggaran Nilai Bersih",
        sub_heading_two_desc: "Jumlah aset tolak jumlah liabiliti individu atau syarikat.",
        select_net_worth:"Select Net Worth",
        sub_heading_three: "Industri Pekerjaan",
        select_occupation: "Pilih Pekerjaan",
        sub_heading_four: "Masukkan Pekerjaan Lain",
        sub_heading_five: "Sumber Dana",
        sub_heading_six: "Masukkan Sumber Dana Lain",
        sub_heading_seven: "Orang Yang Boleh Dilaporkan FATCA AS",
        sub_heading_eight: "Negara/Bidang Kuasa kediaman cukai",
        select_residence_country: "Pilih negara tempat tinggal",
        sub_heading_nine: "Adakah anda mempunyai Nombor TIN?",
        sub_heading_ten: "Masukkan Nombor TIN",
        sub_heading_eleven: "Jika tiada TIN tersedia masukkan Sebab",
        select_reasons: "Pilih Sebab",
        enter_reason: "Masukkan Sebab",
        submit: "Serah",
        dear: "Tuan/Puan",
        message_one: "Berdasarkan maklumat yang anda berikan, nampaknya anda adalah pemastautin AS untuk tujuan cukai.",
        message_two: "Sila ambil perhatian bahawa disebabkan Pematuhan Kawal Selia kami, AAAFx tidak dapat menerima pelanggan yang merupakan pemastautin AS untuk tujuan cukai.",
        message_three: "Kami mengucapkan terima kasih terlebih dahulu atas pemahaman anda.",
        message_four: "Yang ikhlas,",
        message_five: "AAAFx",
        close: "Tutup",
    },
    verify:{
        account_creation: "Penciptaan Akaun",
        financial_details: "Butiran Kewangan",
        verification: "Pengesahan",
        deposit: "Deposit",
        select_platform: "Pilih Platform",
        select_account_type: "Pilih Jenis Akaun",
        select_leverage: "Pilih Leveraj",
        select_base_currency: "Pilih mata wang Asas Akaun",
        select_currency: "Pilih Mata Wang",
        password: "Kata laluan",
        pass_message_one: "Panjang kata laluan minimum ialah 5 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        pass_message_two: "Panjang kata laluan minimum ialah 8 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        of_characters: "daripada aksara",
        lowercase_letter: "Huruf kecil",
        capital_letter: "Huruf besar",
        number: "Nombor",
        special_character: "Aksara khas",
        confirm_password: "Sahkan Kata Laluan",
        create_account: "Cipta Akaun",
        doc_message_one: "Dokumen yang anda serahkan telah ditolak oleh proses pengesahan automatik. Tiket mengenai perkara yang sama telah dibuat, di sini anda boleh memuat naik semula dokumen anda untuk kami mengesahkan dokumen secara manual jika anda mahu.",
        view_ticket: "Lihat Tiket",
    },
    verify_quest_bkp:{
        account_creation: "Penciptaan Akaun",
        questionnaire: "soal selidik",
        verification: "Pengesahan",
        deposit:"Deposit",
        select_platform: "Pilih Platform",
        select_account_type: "Pilih Jenis Akaun",
        select_leverage: "Pilih Leveraj",
        select_base_currency: "Pilih mata wang Asas Akaun",
        select_currency: "Pilih Mata Wang",
        password: "Kata laluan",
        pass_length_alert: "Panjang kata laluan minimum ialah 5 aksara dan mesti mengandungi sekurang-kurangnya 1 huruf kecil, 1 huruf besar 1 nombor dan 1 aksara khas.",
        of_characters: "daripada aksara",
        lowercase_letter: "Huruf kecil",
        capital_letter: "Huruf besar",
        number: "Nombor",
        special_character: "Aksara khas",
        confirm_password: "Sahkan Kata Laluan",
        create_account: "Cipta Akaun",
        doc_message_one: "Dokumen yang anda serahkan telah ditolak oleh proses pengesahan automatik. Tiket mengenai perkara yang sama telah dibuat, di sini anda boleh memuat naik semula dokumen anda untuk kami mengesahkan dokumen secara manual jika anda mahu.",
        view_ticket: "Lihat Tiket",
    },
    close_ticket:{
        heading: "Tiket Ditutup",
        create_request: "CIPTA PERMINTAAN",
        open_tickets: "TIKET TERBUKA",
        ticket_number: "Nombor Tiket",
        trading_id: "ID Perdagangan",
        status: "Status",
        subject: "Subjek",
        created: "Dicipta",
        closed: "Ditutup",
        action: "Tindakan",
        view_ticket: "Lihat Tiket",
        no_tickets_found: "Tiada tiket ditemui",
    },
    open_ticket:{
        heading: "Tiket Terbuka",
        create_request: "CIPTA PERMINTAAN",
        open_tickets: "TIKET TERBUKA",
        closed_ticket: "Tiket Ditutup",
        ticket_number: "Nombor Tiket",
        trading_id: "ID Perdagangan",
        status: "Status",
        subject: "Subjek",
        created: "Dicipta",
        action: "Tindakan",
        view_ticket: "Lihat Tiket",
        no_tickets_found: "Tiada tiket ditemui",
    },
    request_call:{
        success_message:"Permintaan anda untuk panggilan balik telah diterima. Pasukan kami akan menghubungi anda sebentar lagi.",
        ok: "OK",
        request_call_back:"Request Call Back",
        first_name: "Nama Pertama",
        last_name: "Nama Akhir",
        email_id: "ID e-mel",
        phone_number: "Nombor Telefon",
        timezone: "Zon masa",
        date: "Tarikh",
        preferred_time: "Masa Diutamakan",
        department: "Jabatan",
        select_department: "Pilih jabatan",
        new_accounts: "Akaun Baharu",
        deposits: "Deposit",
        withdrawals: "Pengeluaran",
        partnership: "Kerjasama",
        technical_support: "Sokongan Teknikal",
        message: "Mesej",
        send_request: "Hantar Permintaan",
    },
    support_page:{
        success_message:"Tiket Sokongan untuk anda telah berjaya dibuat. Anda boleh menjejakinya di bawah TIKET TERBUKA.",
        ok:"OK",
        support: "Sokongan",
        create_req:"CIPTA PERMINTAAN",
        open_tickets:"TIKET TERBUKA",
        closed_tickets: "TIKET TERTUTUP",
        otp_msg:"Kami telah menghantar OTP ke e-mel berdaftar anda. Sila masukkannya untuk mengesahkan permintaan tiket sokongan.",
        otp: "OTP",
        submit: "Serah",
        reason: "Sebab",
        select_a_reason: "Pilih sebab",
        trading_id: "ID Perdagangan",
        select_trading_account: "Pilih Akaun Perdagangan",
        subject: "Subjek",
        trade_order_id: "ID Pesanan Perdagangan",
        time_of_trade_opening: "Waktu Pembukaan Perdagangan",
        time_of_trade_closing: "Waktu Penutupan Perdagangan",
        instrument_traded: "Instrumen Didagangkan",
        type_of_trade: "Jenis Perdagangan",
        select_trade_type: "Pilih jenis Perdagangan",
        details_of_the_issue: "Butiran isu",
        refund_claim_amount: "Amaun Tuntutan Bayaran Balik",
        message: "Mesej",
        note: "CATATAN",
        file_attachments: "Lampiran Fail",
        file_size_msg: "Saiz dokumen tidak boleh melebihi 1MB",
        file_format_msg: "Format fail (jpeg atau pdf) sahaja",
        lowercase_note: "Catatan",
        note_desc: "Sekiranya berlaku sebarang ralat semasa melakukan sebarang operasi akaun, sila lampirkan juga tangkapan skrin ketika mencipta tiket",
        create_support_request: "Cipta Permintaan Sokongan",
    },
    become_ib:{
        heading: "Memperkenalkan Broker",
        description: "Tingkatkan pendapatan Anda dengan Program IB kami. <br /> Dapatkan pautan khusus anda, kongsikannya dengan rakan anda dan dapatkan komisen apabila mereka berdagang.",
        sub_heading: "Kami menawarkan dua kategori program IB yang tersuai:",
        point_one: "Program IB Standard- Dapatkan terus 20% daripada pendapatan komisen kami daripada pelanggan anda. Ini berguna untuk IB pemula yang ingin bermula dari awal atau yang boleh mula membawa jumlah pelanggan yang terhad kepada kami.",
        point_two: "Program IB Lanjutan- Ini program IB yang ganjarannya sangat tinggi dan disesuaikan untuk IB kami yang lebih besar. Ini berguna untuk seseorang yang mempunyai asas pelanggan yang besar yang boleh membawa volum yang lebih besar.",
        note_one: "Anda boleh beralih daripada Program IB Standard kepada Program IB Lanjutan, setelah rangkaian anda berkembang cukup besar.",
        earn_with: "Dapatkan dengan",
        zero_investment_or: "sifar pelaburan atau",
        experience: "pengalaman",
        weekly_ib: "IB Mingguan",
        commissions: "Komisen",
        payouts: "pembayaran",
        unlimited: "Tidak terhad",
        earnings: "pendapatan",
        potential: "potensi",
        sub_cont_point_four: "Program IB lanjutan yang sangat disesuaikan dan berganjaran tinggi",
        ultra_fast: "Sangat pantas",
        withdrawals_of_ib: "pengeluaran IB",
        commission: "komisen",
        easy_user: "Pengguna yang mudah",
        interface_of: "antara muka",
        ib_portal: "Portal IB",
        dedicated: "Berdedikasi",
        account: "Akaun",
        manager: "Pengurus",
        helpful_and: "Membantu dan",
        free_marketing: "Pemasaran Percuma",
        material: "Bahan",
        become_an_ib: "Jadi IB",
    },
    pamm_acct:{
        title:"PAMM ACCOUNT",
        description_one: "PAMM (Modul Pengurusan Peruntukan Peratusan) ialah akaun pengurusan yang pengurus melaksanakan perdagangan dalam semua sub-akaunnya. Pengurus dan Pelabur bebas memilih struktur yuran prestasi, dan kami akan menguruskan permulaannya.",
        description_two: "AAAFx menyediakan penyelesaian perdagangan PAMM yang sangat fleksibel dan tersuai.",
        sub_title: "Bagaimanakah cara mendaftar sebagai Pengurus PAMM",
        sub_Point_one: "Akaun Pengurus PAMM anda boleh dibuka sebaik sahaja anda mempunyai sekurang-kurangnya empat pelabur dengan jumlah deposit $5,000 atau lebih.",
        sub_Point_two: "Hanya daftar sebagai IB untuk menjadi Pengurus PAMM dengan kami. Daftarkan pelanggan anda menggunakan pautan IB anda, penuhi syarat pertama di atas.",
        sub_Point_three: "Hubungi kami melalui Sembang Langsung atau e-mel kami di",
        sub_Point_four: "Mula peroleh komisen IB di samping Yuran Prestasi PAMM.",
        minimul_investment: "PELABURAN YANG MINIMUM",
        ease_of_access: "KEMUDAHAN AKSES",
        ultimate_trading_conditions: "KEADAAN PERDAGANGAN MUKTAMAD",
        trade_security: "KESELAMATAN PERDAGANGAN",
        request_pamm: "Minta PAMM",
    },
    add_payment_methods:{
        success_message: "Kaedah pembayaran anda telah berjaya ditambahkan. Anda boleh menjejakinya di bawah Tiket Terbuka.",
        ok: "OK",
        otp_message: "Kami telah menghantar OTP kepada e-mel berdaftar anda. Sila masukkannya untuk mengesahkan permintaan tiket sokongan.",
        otp: "OTP",
        submit: "Serah",
        page_heading: "Tambah Kaedah Pembayaran",
        select_payment_method: "Pilih Kaedah Pembayaran",
        select_method: "Pilih Kaedah",
        bank: "Bank",
        credit_card: "Kad Kredit",
        crypto: "Kripto",
        select_crypto_currency: "Pilih Mata Wang Kripto",
        select_crypto: "Pilih Kripto",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "Tambah Butiran Bank Anda",
        bank_name: "Nama Bank",
        account_name: "Nama Akaun",
        account_number: "Nombor Akaun",
        country: "Negara",
        select_country: "Pilih negara",
        iban: "IBAN",
        iban_note: "Bank Saya Tidak mengeluarkan IBAN",
        swift: "Swift",
        bic: "BIC",
        sort_code: "Kod Isih",
        bank_address: "Alamat Bank",
        upload_your_bank_statement: "Muat Naik Penyata Bank Anda",
        upload_doc_info_one: "Saiz dokumen tidak boleh melebihi 1MB",
        upload_doc_info_two: "Format fail (jpeg atau pdf) sahaja",
        note: "Catatan",
        note_msg: "Sekiranya berlaku sebarang ralat semasa melakukan sebarang operasi akaun, sila lampirkan juga tangkapan skrin ketika mencipta tiket",
        create_support_request: 'Cipta Permintaan Sokongan',
        add_your_card_details: "Tambahkan Butiran Kad Anda",
        creadit_card_number: "Nombor Kad Kredit",
        month: "Bulan",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "Tahun",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "Kami memerlukan perkara berikut untuk pengesahan kad",
        varification_msg_one: "Salinan warna bahagian hadapan kad, menunjukkan: nama penuh, tarikh tamat tempoh, nama/logo Bank, 4 angka pertama dan 4 terakhir nombor kad kredit dengan menyembunyikan 8 angka tengah.",
        upload_supporting_document: "Muat Naik Dokumen Sokongan",
        varification_msg_two: "Salinan warna bahagian belakang kad dengan menyembunyikan kod keselamatan CVV. Salinan belakang hendaklah menunjukkan tandatangan pemegangnya",
        add_selected_crypto_address: "Tambah Alamat Kripto yang Dipilih",
        address: "Alamat",
    },
    deposit:{
        account_type: "Jenis Akaun",
        select_type: "Pilih jenis",
        live: "Langsung",
        trading_account: "Akaun Perdagangan",
        select_trading_account: "Pilih Akaun Perdagangan",
        balance: "Baki",
        fund: "DANA",
        amount: "Amaun",
        region: "Wilayah",
        currencies: "Mata wang",
        processing_time: "Masa Pemprosesan",
        action: "Tindakan",
        view_more: "Lihat Lagi",
        currency: "Mata Wang",
        zar: "ZAR",
        swift_code: "Kod Swift",
        beneficiarys_name: "Nama Benefisiari",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "Nombor Akaun",
        user_account_number: "62928423269",
        bank_address: "Alamat Bank",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "Nama Bank",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "Bandar",
        city_info: "London",
        country: "Negara",
        country_info: "United Kingdom",
        dixipay_note: "Dixipay hanya menerima deposit. dalam EURO",
        you_can_deposit: "Anda boleh mendeposit",
        you_can_deposit_msg: "di alamat berikut dan amaun yang setara dalam mata wang akaun yang dipilih akan ditambahkan selepas penukaran",
        copy: "Salin",
        done: "Selesai",
        network_msg: "Rangkaian ERC-20 (USDT, USDC, ETH) disokong, penggunaan mana-mana rangkaian lain tidak akan diterima oleh kami.",
    },
    fund_index: {
        add_funds: "Tambah Dana",
        cancel: "Batal",
        ok: "OK",
        your_request_to_add: "Permintaan anda untuk menambah",
        to_your_demo_account_number: "kepada Nombor Akaun Demo anda",
        has_been_successfully_completed: "telah berjaya diselesaikan",
        your_request_to_withdraw: "Permintaan anda untuk menarik diri",
        from_the_trading_id: "daripada ID perdagangan",
        has_been_received: "telah diterima",
        click_to_proceed_withdrawal: "Sila klik pautan pengesahan yang dihantar kepada ID e-mel berdaftar anda untuk memproses pengeluaran",
        has_been_successfully: "telah Berjaya",
        your_request_to_add_usd: "Permintaan anda untuk menambah USD",
    },
    request_verify: {
        verifying_your_request: "Mengesahkan permintaan anda",
        success: "BERJAYA",
        go_to_transactions: "Pergi ke Transaksi",
        error: "RALAT",
    },
    transactions: {
        list_of_transactions: "Senarai Urus Niaga",
        deposits: "Deposit",
        withdrawals: "Pengeluaran",
        bonus: "Bonus",
        deposit_transactions: "Transaksi Deposit",
        filter_by: "Tapis mengikut",
        select_trading_id: "Pilih ID Perdagangan",
        all: "SEMUA",
        date: "Tarikh",
        account_id: 'ID Akaun',
        currency: "Mata Wang",
        payment_mode: "Mod Pembayaran",
        deposit_amount: "Amaun Deposit",
        status: 'Status',
        no_deposits_yet: "Tiada deposit lagi",
        withdrawal_mode: "Mod Pengeluaran",
        withdrawal_amount: "Amaun Pengeluaran",
        action: "Tindakan",
        view_more : "Lihat Lagi",
        no_withdrawals_yet: "Belum ada pengeluaran lagi",
        bonus_amount: "Amaun Bonus",
        pending : "Belum Selesai",
        no_bonus_transactions_yet: "Belum ada transaksi bonus lagi",
        deposit_currency: "Mata Wang Deposit",
        account_currency: 'Mata Wang Akaun',
        address: 'Alamat',
    },
    withdrawal: {
        kyc_req_msg: "KYC wajib diselesaikan sebelum meminta pengeluaran. Sila serahkan bukti alamat menggunakan tiket sokongan",
        Click_here: "Klik di sini",
        or_email_to: 'or email to',
        with_step_heading: "Bukti Alamat berikut boleh diterima",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "Bil Utiliti",
        with_step_two: "Penyata Bank",
        with_step_three: "Dokumen Cukai Keluaran Kerajaan",
        note: "Catatan",
        note_info: "Bukti alamat mestilah tidak melebihi 4 bulan terdahulu",
        ok: "OK",
        enable_2fa_msg: "2FA wajib didayakan untuk memulakan permintaan pengeluaran. Sila klik butang berikut",
        click_to_enable: "Klik untuk Mendayakan",
        select_trading_id: "Pilih ID Perdagangan",
        account_id: "ID Akaun",
        account_type: "Jenis Akaun",
        platform: 'Platform',
        leverage: "Leveraj",
        currency: "Mata Wang",
        free_margin: "Margin Bebas",
        note_info_two: "Masukkan amaun Pengeluaran dalam Mata Wang Asas Akaun Perdagangan anda.",
        amount: "Amaun",
        mode_of_payment: "Cara Pembayaran",
        create_transaction: "Cipta Transaksi",
        cancel: "Batal",
        add_payment_method: "Tambah Kaedah Pembayaran",
        no_amount_available: "Tiada Amaun tersedia dalam akaun ini",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "Pilih akaun",
    },
    footer: {
        legal_information: "Maklumat Undang-undang",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. ditauliahkan dan dikawal selia oleh Pihak Berkuasa Tingkah Laku Sektor Kewangan Afrika Selatan (FSCA No. 2017/315029/07).",
        risk_warning: "Amaran Risiko",
        risk_warning_info: `Berdagang mata wang spot melibatkan risiko yang besar dan sentiasa ada potensi kerugian. Keputusan perdagangan anda mungkin berbeza-beza. Oleh kerana faktor risiko adalah tinggi dalam perdagangan pasaran pertukaran asing, hanya dana "risiko" yang tulen patut digunakan dalam perdagangan tersebut. Jika anda tiada modal tambahan yang anda sanggup rugi, anda tidak sepatutnya berdagang dalam pasaran pertukaran asing. Tiada sistem perdagangan yang "selamat" pernah dicipta, dan tiada siapa yang boleh menjamin keuntungan atau kebebasan daripada kerugian.`,
    },
    header: {
        welcome: "Selamat datang", 
        profile: 'Profile',
        request_callback: "Minta Panggilan Balik",
        support_ticket: "Tiket Sokongan",
        change_password: "Tukar Kata Laluan",
        logout: "Log Keluar",
    },
    pagination: {
        total_records: "Jumlah Rekod", 
    },
    side_bar: {
        dashboard: "Papan Pemuka",
        manage_accounts: "Urus Akaun",
        fund: "Dana",
        bonus: "Bonus",
        become_a_partner: "Jadi Rakan Niaga",
        tools: "Alatan",
        bonus_and_promotions: 'Bonus & Promosi',
    },
    success_box: {
        otp_varify: "Sila masukkan Pin Satu Kali 6 angka yang ditunjukkan dalam ap Google Authenticator.",
        cancel: "Batal",
        submit: 'Submit',
        trouble_with_2fa: "Ada Masalah dengan Kod Pengesahan Dua Faktor anda?",
        click_varify_with_email: "Klik Di Sini Untuk Mengesahkan Dengan E-mel",
        or: "ATAU",
        click_here: "Klik di sini",
        to_enable_2fa: "untuk mendayakan 2FA anda dan menyelesaikan permintaan anda",
        take_me_back: "Bawa saya kembali",
    },
    tost_message: {
        varify_acc: "Sila sahkan akaun anda untuk mencipta akaun langsung",
        click_to_begin: "Klik untuk memulakan proses pengesahan",
    },
    proof_residence_alert: {
        you_have: "Anda ada",
        days_left_for_proof: "hari masih tinggal untuk mengemukakan bukti kediaman.",
        click_here: "Klik di sini",
        to_upload: "untuk memuat naik",
    },
    closed_trades: {
        login: "Log masuk",
        order: "Pesanan",
        symbol: "Simbol",
        volume: "Volum",
        open_price: "Harga Buka",
        open_time: "Masa Buka",
        commission: "Komisen",
        type: 'Taip',
        sl: "SL",
        tp: "TP",
        close_price: 'Tutup Harga',
        close_time: 'Tutup Masa',
        swap: 'Swap',
        pnl: "PNL",
        comment: 'Komen',
        no_record_found: "Tiada rekod ditemui",
    },
    open_trade: {
        order: 'Order',
        symbol: 'Simbol',
        type: 'Taip',
        volume: "Volum",
        open_price: "Harga Buka",
        pnl: "PNL",
        no_record_found: "Tiada rekod ditemui",
    },
}